/* eslint-disable array-callback-return*/
import React, { useRef, useEffect, useState } from "react";
import { Grid, Divider } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
  ModalExportList,
} from "App/Component/ui";
import { SelectOptionDataMasterBarang } from ".";
import { getByFilterBarangExport, status_barang } from "./helpers";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";

export default function FormFilterGudangUtama({
  formFilter,
  setFormFilter,
  setNewData,
  totalData,
  headTarif = [],
  withExport = true,
}) {
  const [rowsExport, setRowsExport] = useState([]);
  const [readyExport, setReadyExport] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModalExportList, setShowModalExportList] = useState(false);
  const csvLink = useRef(null);

  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const { produsen, jenisHarga } = SelectOptionDataMasterBarang();
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const handleExport = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await getByFilterBarangExport(formFilter);
      if (res.state) {
        defaultToastSuccess(
          "Berhasil, mohon menunggu data sedang dieksport..."
        );
      } else {
        defaultToastError(res.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      defaultToastError(error?.response?.data?.message);
    }

    // if (isNull(formFilter.jenisharga_id)) {
    //   return defaultToastError("Pilih jenis harga terlebih dahulu");
    // }

    // e.preventDefault();
    // setReadyExport(false);
    // setIsLoading(true);
    // const _temp = [];
    // const res = await getByFilterBarang(
    //   formFilter,
    //   1,
    //   totalData,
    //   urlGetWithTarif
    // );
    // if (res.state) {
    //   res.data.map((x) => {
    //     const _tempHarga = {};

    //     headTarif.map((y) => {
    //       const f = x.formulaharga.find((z) => z.tarif_id === y.maskID);

    //       _tempHarga[y.label.replaceAll(" ", "").toLowerCase()] = isNull(f)
    //         ? "FORMULA HARGA KOSONG"
    //         : formatNumber(f.harga);
    //     });

    //     _temp.push({
    //       id: x.id,
    //       name: x.name,
    //       jenisHarga: formFilter.jenisharga_name,
    //       qty_total: x.qty_total,
    //       hargapokok: formatNumber(x.hargapokok),
    //       hargabeli: formatNumber(x.hargabeli),
    //       persediaan: x.qty_total * x.hargapokok,
    //       namaProdusen: x.namaProdusen,
    //       nama_kelas_terapi: x.nama_kelas_terapi,
    //       nama_jenis_obat: x.nama_jenis_obat,
    //       nama_golongan: x.nama_golongan,
    //       qjb: x.qjb,
    //       nama_formula: x.nama_formula,
    //       ..._tempHarga,
    //       createdAt: x.createdAt,
    //       createdBy: x.createdBy,
    //       updatedAt: x.updatedAt,
    //       updatedBy: x.updatedBy,
    //     });
    //   });

    //   setRowsExport(_temp);
    //   setReadyExport(true);
    //   setIsLoading(false);
    // } else {
    //   setRowsExport([]);
    //   setReadyExport(false);
    //   setIsLoading(false);
    //   defaultToastError(res.message);
    // }
  };

  useEffect(() => {
    if (csvLink && csvLink.current && readyExport) {
      csvLink.current.link.click();
    }
  }, [readyExport]);

  return (
    <>
      <p className='fw-600 mb-2 mt-1'>Daftar Barang Perbekalan Farmasi</p>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={3}>
            <InputTextMaster
              name='id'
              label='ID BARANG'
              id='id'
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder='ID Barang'
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='nama'
              label='NAMA BARANG'
              id='nama'
              value={formFilter.nama}
              onChange={handleChange("nama")}
              placeholder='Nama Barang'
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name='produsen_id'
              label='PRODUSEN'
              id='produsen_id'
              withSearch={true}
              data={produsen}
              value={formFilter.produsen_id}
              labelValue={formFilter.produsen_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    produsen_id: null,
                    produsen_name: "Pilih Produsen",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    produsen_id: e.value,
                    produsen_name: e.label,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='jenisharga_id'
              label='JENIS HARGA'
              id='jenisharga_id'
              withSearch={true}
              data={jenisHarga}
              value={formFilter.jenisharga_id}
              labelValue={formFilter.jenisharga_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    jenisharga_id: null,
                    jenisharga_name: "Pilih Jenis Harga",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    jenisharga_id: e.value,
                    jenisharga_name: e.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              needParse={false}
              name="status_barang"
              label="STATUS BARANG"
              id="status_barang"
              withSearch={false}
              value={formFilter.status}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  status: e.target.value,
                });
              }}
              data={status_barang}
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          style={{
            gap: "1rem",
          }}
          alignItems='center'>
          {withExport && (
            <>
              <MasterButton
                type={"button"}
                color='primary-cyan'
                name={"Export List"}
                size='md'
                onClick={() => setShowModalExportList(!showModalExportList)}
              />

              <MasterButton
                type={"button"}
                color='warning'
                name={isLoading ? "Loading..." : "EXPORT"}
                disabled={isLoading}
                size='md'
                onClick={handleExport}
              />
              {/* <CSVLink
                filename={`Daftar Barang.csv`}
                data={dataExport ?? []}
                headers={headerExport ?? []}
                separator={EXCEL_DEFAULT_SEPARATOR}
                target='_blank'
                ref={csvLink}
                style={{ display: "none" }}></CSVLink> */}
            </>
          )}

          <MasterButton
            name={"CARI"}
            type='submit'
            outline={true}
            color={"green"}
            size={"md"}
          />
        </Grid>

        {/* <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            type={"submit"}
            size={"md"}
          />
        </Grid> */}
        <br />
      </form>
      <Divider />

      {showModalExportList && (
        <ModalExportList
          title={"Export List Master Barang Farmasi"}
          showModal={() => setShowModalExportList(false)}
          type='master_barang_farmasi'
        />
      )}
    </>
  );
}
